import { Component, HostListener, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs';
import { splitFilename } from 'src/app/helpers/file-helpers';
import { ActiveSessionModel } from 'src/app/models/active-session.model';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'tx-pending-takeover-sessions-dialog',
  templateUrl: './pending-takeover-sessions-dialog.component.html',
  styleUrl: './pending-takeover-sessions-dialog.component.scss',
})
export class PendingTakeoverSessionsDialogComponent implements OnInit {
  @Input() activeSessions: ActiveSessionModel[] = [];
  @Input() casId: string = '';
  public activeTabId = '';
  public closeEnabled: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private sessionService: SessionService
  ) {}

  @HostListener('document:visibilitychange', ['$event'])
  onDocumentVisibilityChange(event: Event): void {
    if (document.visibilityState === 'visible') {
      this.getSessions();
    }
  }

  ngOnInit(): void {
    this.activeSessions.forEach((s) => {
      if (s.sessionId) {
        s.url = this.buildResumeSessionSafeUrl(s.sessionId, s.filename);
      }
    });
    if (this.activeSessions.length > 0) {
      this.activeTabId = this.activeSessions[0].sessionId;
    }
  }

  public buildResumeSessionSafeUrl(sessionId: string, filename: string): SafeResourceUrl {
    const url = this.getResumeSessionUrl(sessionId, filename);
    const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    return safeUrl;
  }

  public getResumeSessionUrl(sessionId: string, filename: string) {
    const extension = splitFilename(filename).extension;
    const isPdf = extension.toLowerCase() === 'pdf';
    const url = environment.endpoints.baseUrl + (isPdf ? '/pdf' : '') + '?resume=' + sessionId;

    return url;
  }

  private removeSession(session: ActiveSessionModel) {
    const idx = this.activeSessions.findIndex((s) => s.sessionId == session.sessionId);

    if (idx > -1) {
      // check if the session we are about to remove is the active tab
      // if it is, set the first session to be the active tab to avoid having no tab selected
      if (this.activeTabId === session.sessionId) {
        this.activeTabId = this.activeSessions[0].sessionId;
      }

      this.activeSessions.splice(idx, 1);
    }

    if (this.activeSessions.length == 0) {
      this.activeModal.close(true);
    }
  }

  public completeTakeover(session: ActiveSessionModel, event: any = null) {
    if (event) {
      // stop propagation of the click event to prevent the activeTabId from being updated when not intended
      // otherwise, the activeTabId is updated because the clicked a element is inside of an element with ngbNavLink
      event.stopPropagation();
    }
    this.sessionService.completeTakeover(session)
    .pipe(take(1))
    .subscribe(res => {
      this.removeSession(session);
    });
  }

  private getSessions() {
    if (this.casId) {
      this.sessionService
        .getPendingCaseSessions(this.casId)
        .pipe(take(1))
        .subscribe((res) => {
          if (res && res.length > 0) {
            // sync the list by checking if every session is present in the result
            // if it's not, remove it from the list
            // don't rebuild the list because we lose the iframes that way
            this.activeSessions.forEach((as) => {
              const idx = res.findIndex((s) => s.sessionId === as.sessionId);

              if (idx == -1) {
                this.removeSession(as);
              }
            });
            
          } else {
            this.activeModal.close(true);
          }
        });
    }
  }
}
